module.exports = __webpack_public_path__ + "img/LongAdmin22.3a6d4a57.jpg";